import { OnInit } from '@angular/core';
import { getActiveProjectSelector } from '../projects/projects.reducer';
import { Store } from '@ngrx/store';
import { AlertPaymentService } from '../../shared/services/alert-payment.service';
var LeftMenuComponent = /** @class */ (function () {
    function LeftMenuComponent(store, alertPaymentService) {
        var _this = this;
        this.store = store;
        this.alertPaymentService = alertPaymentService;
        this.creatingNewProject = false;
        this.store.select(getActiveProjectSelector).subscribe(function (config) {
            if (config && config.projectId) {
                _this.activeType = config.activeType;
            }
            else {
                _this.creatingNewProject = true;
            }
        });
    }
    LeftMenuComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.alertPaymentService.onActivatePaymentAlert.subscribe(function (isPaymentFailed) {
            _this.failedPayment = isPaymentFailed;
        });
    };
    Object.defineProperty(LeftMenuComponent.prototype, "isCreatingNewProject", {
        get: function () {
            return this.creatingNewProject;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LeftMenuComponent.prototype, "creatorPageForActiveType", {
        get: function () {
            switch (this.activeType) {
                case 'POPUP':
                    return 'popup';
                case 'BUBBLE':
                    return 'bubble';
                default:
                    return 'select';
            }
        },
        enumerable: true,
        configurable: true
    });
    return LeftMenuComponent;
}());
export { LeftMenuComponent };
